import axios from "axios";
import { useAuth } from "../context/useAuth";

const useRefreshToken = () => {
  const { setAuth } = useAuth();

  const refresh: () => Promise<string> = async () => {
    const response = await axios
      .create({
        baseURL: `${process.env.REACT_APP_BASE_URL}/api`,
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      })
      .get(`/token/refresh`);

    setAuth((prev) => {
      return { ...prev, accessToken: response.data.token };
    });
    return response.data.token;
  };
  return refresh;
};

export default useRefreshToken;
